import { render } from "./LegoStepInvoice.vue?vue&type=template&id=73dfab35"
import script from "./LegoStepInvoice.vue?vue&type=script&lang=js"
export * from "./LegoStepInvoice.vue?vue&type=script&lang=js"
script.render = render

export default script